var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "single-uploader",
    "class": {
      'blank': _vm.blank
    }
  }, [_vm.mode === 'wechat' ? _c('WechatUploader', {
    ref: "uploader",
    staticClass: "single",
    "class": _vm.uploaderClass,
    attrs: {
      "size": 1,
      "can-modify": _vm.canModify,
      "container-style": {
        'opacity': _vm.opacity,
        'z-index': 1,
        position: 'relative'
      },
      "remove-class": _vm.removeClass
    },
    on: {
      "add": _vm.onAdd,
      "remove": _vm.onRemove,
      "load": _vm.onLoad,
      "finish": _vm.onFinish
    }
  }) : _c('InputUploader', {
    ref: "uploader",
    staticClass: "single",
    "class": _vm.uploaderClass,
    attrs: {
      "size": 1,
      "can-modify": _vm.canModify,
      "accept": _vm.accept,
      "container-style": {
        'opacity': _vm.opacity,
        'z-index': 1,
        position: 'relative'
      },
      "remove-class": _vm.removeClass
    },
    on: {
      "add": _vm.onAdd,
      "remove": _vm.onRemove,
      "load": _vm.onLoad,
      "finish": _vm.onFinish
    }
  }), !_vm.maskVisible ? _c('div', {
    staticClass: "mock-background",
    style: _vm.backgroundStyle
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _c('p', [_vm._v(_vm._s(_vm.hint))])])]) : _vm._e(), _vm.maskVisible ? _c('div', {
    staticClass: "mask"
  }, [_c('DaisySpinner', {
    staticClass: "dark"
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('p', [_c('i', {
    staticClass: "icon"
  }, [_vm._v("")])]);
}];
export { render, staticRenderFns };